import { cva } from '@allenai/varnish-panda-runtime/css';
import type { RecipeVariantProps } from '@allenai/varnish-panda-runtime/types';

const linkRecipe = cva({
    base: {
        fontWeight: 'medium', // Do we want this?
        cursor: 'pointer',
        color: '[inherit]',
        _disabled: {
            color: 'text.disabled',
            cursor: 'not-allowed',
        },
    },
    variants: {
        color: {
            default: {
                color: 'links',
                _hover: {
                    color: 'links.hovered',
                },
            },
            reversed: {
                color: 'links.reversed',
                _hover: {
                    color: 'links.hovered.reversed',
                },
            },
            text: {
                color: 'text',
            },
            primary: {
                color: 'elements.primary.fill',
            },
            secondary: {
                color: 'elements.secondary.fill',
            },
            tertiary: {
                color: 'elements.tertiary.fill',
            },
        },
        underline: {
            // not implemented: `hover` only version
            // can manually use `none` with a _hover style
            always: {
                textDecorationLine: 'underline',
                textDecorationColor: '[currentColor/50]',
                _hover: {
                    _notDisabled: {
                        textDecorationColor: '[inherit]',
                    },
                },
            },
            none: {
                textDecoration: 'none',
            },
        },
        size: {
            small: {
                fontSize: 'sm',
            },
            medium: {
                fontSize: 'md',
            },
            large: {
                fontSize: 'lg',
            },
        },
    },
    defaultVariants: {
        underline: 'always',
    },
});

type LinkRecipeProps = RecipeVariantProps<typeof linkRecipe>;

export { linkRecipe, linkRecipe as default };
export type { LinkRecipeProps };
